import React, { useState, useEffect } from 'react';
import SelecionarCategoriaProduto from '../Utils/SelecionarCategoriaProduto';
import SelecionarMarca from '../Utils/SelecionarMarca';
import ImageCropper from '../Utils/ImageCropper';
import { Form, Button, Card, Alert, Col} from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';
import PhoneInput from '../Input/PhoneInput'


const PerfilForm = () => {
    const {
      crud,
      setLinks, 
      setBtns,
      auth,
      setTitle,
      navigateTo,
    } = useProvider();
    const [empresa, setEmpresa] = useState(auth?.empresa);
    const [telefoneWhatsapp, setTelefoneWhatsapp] = useState(null);
    const [fileFoto, setFileFoto] = useState(null);
    const [formErrors, setFormErrors] = useState([]);
    const { patch, get, loading } = crud || {};
    const formData = new FormData();
    
    setTitle("Perfil de cadastro");

  

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([{ icon: 'bi-check-lg', onClick: handleSubmit }]);

        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, empresa, fileFoto, telefoneWhatsapp]); // Removidas dependências desnecessárias

    // Carrega o empresa ao iniciar
    useEffect(() => {
        carregarEmpresa();
    }, [setEmpresa]);
    
  

    const carregarEmpresa = async () => {
        try {
            const response = await get(`/gvendas/empresas/?expand=proprietario`,'pagina');
            if (response) {
                setEmpresa(response[0].results[0]);
                setTelefoneWhatsapp(response[0].results[0].telefone_whatsapp);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar alterações.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            nome_da_loja: err.response?.data?.nome_da_loja || err.response?.data?.url,
            telefone_whatsapp: err.response?.data?.telefone_whatsapp,
            descricao: err.response?.data?.descricao,
            agradecimento: err.response?.data?.agradecimento,
            instrucoes: err.response?.data?.instrucoes,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const errors = {};
        if (empresa?.nome_da_loja === '') errors.nome_da_loja = 'Por favor, informe o nome do seu negócio.';
        if (empresa?.telefone_whatsapp === '') errors.telefone_whatsapp = 'Por favor, informe o whatsapp do seu negócio.';
        if (empresa?.proprietario?.email === '') errors.email = 'Por favor, informe o email para redefinição de senha.';
        
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({});

        if(fileFoto) formData.append('logomarca', fileFoto);
        formData.append('nome_da_loja', empresa?.nome_da_loja);
        formData.append('telefone_whatsapp', telefoneWhatsapp);
        formData.append('descricao', empresa?.descricao);
        formData.append('agradecimento', empresa?.agradecimento);
        formData.append('instrucoes', empresa?.instrucoes);
        formData.append('proprietario.email', empresa?.proprietario?.email);
        
        try {
            const response = await patch(formData, `/gvendas/empresas/${empresa?.id}/?expand=juros,configuracoes`, 'multipart/form-data');
            if (response &&response.length) {
                Toast.fire({
                    icon: "success",
                    title: `Atualizada com sucesso`
                });
                navigateTo(-1);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };
    

    return (
        <div className="">
              <Card>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        <ImageCropper label="Logomarca" foto={empresa?.logomarca} setFoto={setFileFoto}/>
                        
                        <Form.Group controlId="formNome">
                            <Form.Label>Nome do seu negócio *</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={empresa?.nome_da_loja || ''} 
                                onChange={(e) => 
                                    setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        nome_da_loja: e.target.value
                                    }))
                                }
                            />
                            {formErrors.nome && <Alert variant="danger">{formErrors.nome}</Alert>}
                        </Form.Group>
                        <PhoneInput phone={telefoneWhatsapp} setPhone={setTelefoneWhatsapp} formErrors={formErrors} is_obrigatorio={true} label={"Telefone WhatsApp"}/>
                        <Form.Group controlId="formEmail">
                            <Form.Label>Email * <span className="small text-muted">usado para redefinição de senha</span></Form.Label>
                            <Form.Control 
                                type="text" 
                                value={empresa?.proprietario?.email || ''} 
                                onChange={(e) => 
                                    setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        proprietario: {
                                            ...prevEmpresa.proprietario,
                                            email: e.target.value
                                        }
                                    }))
                                }
                            />
                            {formErrors.email && <Alert variant="danger">{formErrors.email}</Alert>}
                        </Form.Group>
                        {formErrors.telefone_whatsapp && <Alert variant="danger">{formErrors.telefone_whatsapp}</Alert>}
                        <Form.Group controlId="formDescricao">
                            <Form.Label>Sobre o negócio</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={4}
                                value={empresa?.descricao || ''} 
                                onChange={(e) => 
                                    setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        descricao: e.target.value
                                    }))
                                }
                            />
                            {formErrors.nome && <Alert variant="danger">{formErrors.nome}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formAgradecimento">
                            <Form.Label>Mensagem de agradecimento</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3}
                                value={empresa?.agradecimento || ''} 
                                onChange={(e) => 
                                    setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        agradecimento: e.target.value
                                    }))
                                }
                            />
                            {formErrors.nome && <Alert variant="danger">{formErrors.nome}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formInstrucoes">
                            <Form.Label>Instruções (forma de pagamento ex: pix)</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3}
                                value={empresa?.instrucoes || ''} 
                                onChange={(e) => 
                                    setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        instrucoes: e.target.value
                                    }))
                                }
                            />
                            {formErrors.nome && <Alert variant="danger">{formErrors.nome}</Alert>}
                        </Form.Group>
                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            {loading ? empresa ? "Salvando..." : 'Carregando...' : 'Salvar alterações'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};


export default PerfilForm;